import { createContext, useContext } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './app.scss';
import { AutotestPage } from './pages/autotest';

/* -------------------------------------------------------------------------------- *\
|                               ClockContext
\* -------------------------------------------------------------------------------- */
export const ClockContext = createContext<string>("");
export const useClockContext = () =>
{
    return useContext(ClockContext);
};
/* -------------------------------------------------------------------------------- *\
|                               App
\* -------------------------------------------------------------------------------- */
function App()
{
    return (
        <BrowserRouter basename="/">
                <Routes>
                    <Route path="*" element={<AutotestPage />} />
                </Routes>
        </BrowserRouter>
    );
}

export default App;
